import getTableConversationRelation from '../utils/getTableConversationRelation';
import TableView from '../store/schema/TableView';
import { getIsPinnedTimestamp } from '../utils/pinningUtils';
import { getListViewStore } from '../store/Store';
import { getOwaMiniStrings } from 'owa-strings/owa-mini-strings';
import { MailListDataPropertyEnum } from './MailListDataPropertyEnum';
import { TableQueryType } from '../store/schema/TableQuery';

export default (
    conversationId: string,
    tableView: TableView,
    propertyType: MailListDataPropertyEnum
) => {
    const tableConversationRelation = getTableConversationRelation(conversationId, tableView.id);
    const conversationItem = getListViewStore().conversationItems.get(conversationId);

    if (!tableConversationRelation || !conversationItem) {
        return null;
    }

    switch (propertyType) {
        case MailListDataPropertyEnum.LastDeliveryTimeStamp:
            return tableConversationRelation.lastDeliveryTimeStamp;

        case MailListDataPropertyEnum.LastDeliveryOrRenewTimeStamp:
            return tableConversationRelation.lastDeliveryOrRenewTimeStamp;

        case MailListDataPropertyEnum.LastModifiedTime:
            return tableConversationRelation.lastModifiedTimeStamp;

        case MailListDataPropertyEnum.Subject:
            return conversationItem.subject || getOwaMiniStrings().noSubject;

        case MailListDataPropertyEnum.ParentFolderId:
            if (tableView.tableQuery.type === TableQueryType.Search) {
                return tableConversationRelation.parentFolderId;
            }
            // Use tableView.tableQuery.folderId for non-search scenarios,
            // because parentFolderId is not returned for findConversation
            return tableView.tableQuery.folderId;

        case MailListDataPropertyEnum.UniqueRecipients:
            return tableConversationRelation.uniqueRecipients;

        case MailListDataPropertyEnum.UniqueSenders:
            return tableConversationRelation.uniqueSenders;

        case MailListDataPropertyEnum.LastSender:
            return tableConversationRelation.lastSender;

        case MailListDataPropertyEnum.UnreadCount:
            return tableConversationRelation.unreadCount;

        case MailListDataPropertyEnum.PreviewText:
            return tableConversationRelation.previewText;

        case MailListDataPropertyEnum.IsPinned:
            return getIsPinnedTimestamp(tableConversationRelation.lastDeliveryOrRenewTimeStamp);

        case MailListDataPropertyEnum.FlagStatus:
            return tableConversationRelation.flagStatus;

        case MailListDataPropertyEnum.ShouldShowRSVP:
            return tableConversationRelation.shouldShowRSVP;

        case MailListDataPropertyEnum.RsvpUnitAriaDetails:
            return tableConversationRelation.rsvpUnitAriaDetails;

        default:
            return null;
    }
};
